import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';

@Component({
    selector: 'app-etf-contract-table-widget',
    templateUrl: './etf-contract-table-widget.component.html',
    styleUrl: './etf-contract-table-widget.component.scss',
})
export class AppEtfContractTableWidgetComponent {
    @Input() widgetData!: WidgetModel;
}